export const DELETE_DOCUMENTS_FAILURE = 'DELETE_DOCUMENTS_FAILURE';

export const deleteDocumentsFailure = error => ({
    type: DELETE_DOCUMENTS_FAILURE,
    payload: error,
    error: true,
});
